{
    "Accessibility menu": "Meni dostopnosti",
    "Close": "Zapri",
    "Content adjustments": "Prilagoditve vsebine",
    "Navigation adjustments": "Prilagoditve navigacije",
    "Text Align": "Poravnava besedila",
    "Align Left": "Poravnaj levo",
    "Align Center": "Sredinska poravnava",
    "Align Right": "Poravnaj desno",
    "Adjust Font Size": "Prilagodi velikost pisave",
    "Highlight Title": "Označi naslov",
    "Highlight Links": "Označi povezave",
    "Readable Font": "Bralna pisava",
    "Colour adjustments": "Prilagoditve barv",
    "Dark Contrast": "Temni kontrast",
    "Light Contrast": "Svetli kontrast",
    "High Contrast": "Visoki kontrast",
    "High Saturation": "Visoka nasičenost",
    "Low Saturation": "Nizka nasičenost",
    "Monochrome": "Monokromno",
    "Tools": "Orodja",
    "Reading Guide": "Bralni vodnik",
    "Big Cursor": "Velik kazalec",
    "Increase Font Size": "Povečaj velikost pisave",
    "Decrease Font Size": "Zmanjšaj velikost pisave",
    "Letter Spacing": "Razmik med črkami",
    "Line Height": "Višina vrstice",
    "Font Weight": "Debelina pisave",
    "Dyslexia Font": "Pisava za disleksijo",
    "Language": "Jezik",
    "Accessibility widget": "Odpri meni dostopnosti",
    "Accessibility Profiles": "Profili dostopnosti",
    "Cognitive Disability": "Kognitivna oviranost",
    "Seizure Safe": "Varno za napade",
    "Accessibility statement": "Izjava o dostopnosti",
    "ADHD": "ADHD",
    "Low Vision": "Slabovidnost",
    "Pause Animations": "Ustavi animacije",
    "Animation paused": "Animacija zaustavljena",
    "Reset all settings": "Ponastavi vse nastavitve",
    "Shortcut:": "Bližnjica:",
    "Epilepsy Safe Mode": "Način, varen za epilepsijo",
    "Mute sounds": "Utišaj zvoke",
    "Page read": "Branje strani",
    "Page read controls": "Nadzor branja strani",
    "Pause": "Premor",
    "Resume": "Nadaljuj",
    "Stop": "Ustavi",
    "Settings": "Nastavitve",
    "Speed": "Hitrost",
    "Voice": "Glas",
    "Close accessibility menu": "Zapri meni dostopnosti",
    "Back to accessibility menu": "Nazaj na meni dostopnosti",
    "Search languages": "Iskanje jezikov",
    "Selected language": "Izbrani jezik",
    "View accessibility statement (opens in new window)": "Poglej izjavo o dostopnosti (odpre se v novem oknu)",
    "Visit CookieYes website (opens in new window)": "Obišči spletno mesto CookieYes (odpre se v novem oknu)",
    "Reset all accessibility settings to default": "Ponastavi vse nastavitve dostopnosti na privzeto"
}
